import { Customer } from '../customers'
import { CommonSheet } from '../types'

export interface CustomerSheetMeta {
  customer?: Customer
  customerReference?: string
  handleCustomerUpdate?: (customer: Customer) => void
  handleCustomerSelect?: (customer: Customer) => void
}

export const CustomerActionIds = {
  ASSIGN_FEE_WALLETS: 'ASSIGN_FEE_WALLETS',
  ASSIGN_CUSTOMER_FEE: 'ASSIGN_CUSTOMER_FEE',
} as const

export type CustomerActionId = (typeof CustomerActionIds)[keyof typeof CustomerActionIds]

export interface CustomerActionSheet extends CommonSheet {
  actionId?: CustomerActionId
  meta?: CustomerSheetMeta
}
